interface StylusClassNameParts {
  appAlias: string;
  fileName: string;
  component?: string;
}

export const getStylusClassName = ({
  appAlias,
  fileName,
  component
}: StylusClassNameParts) => {
  if (!component) {
    return `eapp-${appAlias}-${fileName}`;
  }

  return `eapp-${appAlias}-${fileName}-${component}`;
};
